import Vue from 'vue'
import App from './App.vue'
import router from "./route/routes"
import store from "./store/store"
import Meta from "vue-meta"
import SEO from './helpers/SEO'
import lazyLoad from './helpers/Lazyload'
import VueGtm from '@gtm-support/vue2-gtm';
import LottieAnimation from 'lottie-web-vue'
import { initRollout } from "@/feature-flags/index.js"
import { initUnleashFeatureFlags } from "@/feature-flags/unleash-config.js"

Vue.config.productionTip = false
Vue.directive("lazyload", lazyLoad)
Vue.use(Meta)
Vue.mixin(SEO)
Vue.use(LottieAnimation)
Vue.use(VueGtm, {
    id: [
        process.env.VUE_APP_GTM_CODE,
    ],
    enabled: true,
    debug: true,
    loadScript: true,
    vueRouter: router,
});

async function bootstrap() {
  try {
    await initRollout();
    await initUnleashFeatureFlags(Vue);
  } catch (err) {
    console.log(err);
  }

  new Vue({
    render: h => h(App),
    router,
    store
  }).$mount('#app');
}

bootstrap();
